import { useState, useEffect } from "react";
import { Box, Typography, Popover } from "@mui/material";
import { getColorTraductor, handleOrder } from "../../../../components/Utils/Utils.ts";
import { colors, fonts } from "../../../../assets/styles/theme.ts";
import { Search, CalendarMonth } from "@mui/icons-material";
import CircularProgress from '@mui/material/CircularProgress';
import { buttonsMuestrasForClient } from "../../../../components/ButtonsTable/ButtonsTable";
import {
  StyledTypography,
  BoxInputs,
  BoxHeader,
  BoxSubHeader,
  Styled,
} from "./StyledInfoMuestras.js";
import { RenderImgStyled } from "../../../Task/Items/SuperAdminStyled";
import {
  getPlantabyCliente2,
  imprimirMuestras,
  imprimirResumen,
} from "../../../../api/Clientes";
import {
  getAllInfoMuestras,
  getAllEquipoByClienteOptions,
  getAllPuntoTomasOptionsClienteOptions,
  getAllComponenteClienteOptions,
  getAllLubricanteOptionsClienteOptions,
  getAllEstadoClientesOptions,
} from "../../../../api/Muestras.js";
import { getEquipoOptionsPuntosDeToma } from "../../../../api/EndPoints.ts";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useAuth } from "../../../../context/AuthContext.jsx";
import { Chip } from "@mui/material";
import { formatearFecha } from "../../../../components/Utils/Utils.ts";
import Tables from "../../../../components/Tables/Tables";
import Modal from "../../../../components/Modal/Modal";
import Input from "../../../../components/Input/Input.jsx";
import Toast from "../../../../components/Toast/Toast";
import CustomButton from "../../../../components/Button/CustomButton.tsx";
import Print from "../../../../assets/Icons/Buttons/Muestras/Print.svg";
import Preloader from "../../../../components/Preloader/Preloader.jsx";
import CustomRow from "../../../../components/CustomRow/CustomRow.tsx";
import RenderImg from "../../../../components/RenderImg/RenderImg.tsx";
import SetIcon from "../../../../assets/Icons/Buttons/Clientes/SetIcon.svg";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import moment from "moment";
import dayjs from "dayjs";
import "dayjs/locale/es";
dayjs.locale("es");

const columns = [
  { id: "codigo", label: "Nro. Muestra" },
  { id: "fechaAnalisis", label: "Fecha Análisis" },
  { id: "planta", label: "Planta" },
  { id: "equipo", label: "Equipo" },
  { id: "puntoDeToma", label: "Pto. de Toma" },
  { id: "lubricante", label: "Lubricante" },
  { id: "estadoFinal", label: "Estado Final" },
  { id: "buttons" },
];

const InfoMuestras = () => {
  const { token } = useAuth();
  const [isLoading, setIsLoading] = useState();
  const [statusModal, setModalStatus] = useState(false);
  const [datosModal, setDatosModal] = useState("");
  const [typeModal, setTypeModal] = useState("muestras");
  const [pageCount, setPageCount] = useState(1);
  const [itemsCount, setItemsCount] = useState(1);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [msjToast, setMsjToast] = useState("");
  const [key, setKey] = useState(0);
  const [muestrasIds, setMuestrasIds] = useState([]);

  const [muestras, setMuestras] = useState([]); // LLENA LA TABLA
  const [paginaActual, setPaginaActual] = useState(1);
  const [desdePaginador, setDesdePaginador] = useState(false);
  const [orderBy, setOrderBy] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [mostrarChip, setMostrarChip] = useState(false);

  //Filtros
  const [loader, setLoader] = useState(false);
  const [selectedOptionPla, setSelectedOptionPla] = useState(null);
  const [plantas, setPlantas] = useState([]);
  const [selectedOptionEquipo, setSelectedOptionEquipo] = useState(null);
  const [equipo, setEquipo] = useState([]);
  const [selectedOptionPuntoDeToma, setSelectedOptionPuntoDeToma] =
    useState(null);
  const [puntoDeToma, setPuntoDeToma] = useState([]);
  const [searchNroMuestra, setSearchNroMuestra] = useState("");
  const [selectedOptionComponente, setSelectedOptionComponente] =
    useState(null);
  const [componente, setComponente] = useState([]);
  const [selectedOptionLubricante, setSelectedOptionLubricante] =
    useState(null);
  const [lubricante, setLubricante] = useState([]);
  const [searchNroOt, setSearchNroOt] = useState("");
  const [searchDesde, setSearchDesde] = useState(null);
  const [searchHasta, setSearchHasta] = useState(null);
  const [fechaErrorCalendar, setFechaErrorCalendar] = useState("");
  const [continuarCalendar, setContinuarCalendar] = useState(false);
  const [checkboxState, setCheckboxState] = useState({});
  const [checkBoxBack, setCheckBoxBack] = useState("")
  const [estadosFinales, setEstadosFinales] = useState([]);
  const cargarCheckbox = (nameCheck) => checkboxState[nameCheck] === true;

  useEffect(() => {
    if (token.clienteId !== "") {
      getPlantabyCliente2(parseInt(token.clienteId, 10)).then((res) => {
        setPlantas(
          res.data.map((res) => {
            return { label: res.desc_pla, value: res.id, subLabel: res.cliente.description, };
          })
        );
      });
      getAllEquipoByClienteOptions().then(
        (res) => {
          setEquipo(
            res.data.map((res) => {
              return { label: res.desc_equi, value: res.id, code: res.codigo_equi };
            })
          );

        }
      );
      getAllComponenteClienteOptions().then((res) => {
        setComponente(
          res.data.map((res) => {
            return {
              label: res.desc_com,
              value: res.id,
            };
          })
        );
      });

      getAllLubricanteOptionsClienteOptions().then((res) => {
        setLubricante(
          res.data.map((res) => {
            return {
              label: res.desc_lub,
              value: res.id,
              code: res.codigo_lub,
            };
          })
        );
      });
      getAllEstadoClientesOptions().then((res) => {
        setEstadosFinales(
          res.data.map((res) => {
            return {
              id: res.id,
              label: res.desc_efm,
              icon: res.imagen_efm,
              color: res.color_efm
            };
          })
        );
      });
    }
  }, []);
  useEffect(() => {
    const fetchPuntoDeToma = async () => {
      const res = selectedOptionEquipo
        ? await getEquipoOptionsPuntosDeToma(selectedOptionEquipo.value)
        : await getAllPuntoTomasOptionsClienteOptions();

      const options = res.data.map((item) => ({
        label: item.desc_pto,
        value: item.id,
        code: item.codigo_pto,
        subLabel: `${item.equipo.tag_planta}-${item.equipo.denominacion}`,
      }));

      setPuntoDeToma(options);

      if (options.length === 1) {
        setSelectedOptionPuntoDeToma(options[0]);
      } else {
        setSelectedOptionPuntoDeToma(null);
      }
    };

    fetchPuntoDeToma();
  }, [selectedOptionEquipo]);
  useEffect(() => {
    fetchMuestrasAllFilters();

  }, [
    paginaActual,
    orderBy,
    selectedOptionPla,
    selectedOptionEquipo,
    selectedOptionPuntoDeToma,
    selectedOptionComponente,
    selectedOptionLubricante,
    searchNroMuestra,
    searchNroOt,
    checkBoxBack,
    continuarCalendar,
    mostrarChip,
  ]);
  useEffect(() => {
    if (continuarCalendar) {
      fetchMuestrasAllFilters();
      setContinuarCalendar(false);
    }
  }, [continuarCalendar]);

  const fetchMuestrasAllFilters = async () => {
    setLoader(true);
    let fechaParaDesdeBackend = "";
    let fechaParaHastaBackend = "";

    if (continuarCalendar) {
      fechaParaDesdeBackend = searchDesde
        ? searchDesde.hour(0).minute(0).second(0).format("YYYY-MM-DD HH:mm:ss")
        : "";
      fechaParaHastaBackend = searchHasta
        ? searchHasta.hour(23).minute(59).second(59).format("YYYY-MM-DD HH:mm:ss")
        : "";
    }
    try {
      const filtros = {
        paginaActual: paginaActual,
        pageSize: 20,
        order: orderBy ?? "",
        idPlanta: selectedOptionPla?.value ?? "",
        idEquipo: selectedOptionEquipo?.value ?? "",
        idPuntoToma: selectedOptionPuntoDeToma?.value ?? "",
        idComponente: selectedOptionComponente?.value ?? "",
        idLubricante: selectedOptionLubricante?.value ?? "",
        codigoMuestra: searchNroMuestra,
        codigoOT: searchNroOt,
        fechaDesde: fechaParaDesdeBackend || (searchDesde ? searchDesde.hour(0).minute(0).second(0).format("YYYY-MM-DD HH:mm:ss") : ""),
        fechaHasta: fechaParaHastaBackend || (searchHasta ? searchHasta.hour(23).minute(59).second(59).format("YYYY-MM-DD HH:mm:ss") : ""),
        estadosFinales: checkBoxBack ?? []
      };
      const res = await getAllInfoMuestras(filtros);
      if (!desdePaginador) {
        setPaginaActual(1);
      }
      setDesdePaginador(false);
      setPageCount(res.data.totalPages);
      setItemsCount(res.data.totalItems);
      setMuestrasIds(res.data.filteredIds);
      const muestrasFormateadas = res.data.items.map((item) => {
        const fechaFormateada = moment(item.fecha_analisis_mue).isValid()
          ? moment(item.fecha_analisis_mue).format("DD/MM/YYYY")
          : "";
        return {
          fechaAnalisis: fechaFormateada,
          codigo: item.codigo_mue,
          lote: item.orden_trabajo?.nro_lote_otra,
          denominacion: item.desc_mue,
          cliente: item.orden_trabajo?.cliente?.id,
          clienteDesc: item.orden_trabajo?.cliente?.desc_cli,
          planta: item.planta?.description,
          estado: item.estado_mue,
          id: item.id,
          equipo: item.equipo?.description,
          horasUso: item.horas_equipo_mue,
          horasUsoLubricante: item.horas_lubricante_mue,
          responsable: item.responsable_toma_mue,
          punto: item.punto_toma?.description,
          ordenTrabajo: item.orden_trabajo,
          puntoDeToma: item.punto_toma?.description,
          conjunto: item.conjunto_analisis,
          lubricante: item.lubricante?.description,
          fechaTomaMue: item.fecha_toma_mue,
          ...(item.estado_final && {
            estadoFinal: (
              <CustomRow
                colorBorder={item.estado_final.color_efm}
                label={item.estado_final.desc_efm}
                svg={item.estado_final.imagen_efm}
              />
            ),
          }),
          datos: item,
        };
      });
      setMuestras(muestrasFormateadas);
      setLoader(false);
    } catch (error) {
      console.error(error);
    }
  };
  const handleImprimirResumen = () => {
    const bodyImprimir = muestrasIds;
    imprimirResumen(bodyImprimir)
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "resumen.pdf"); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error al descargar el PDF:", error);
      });
  };
  const handleImprimirMuestras = () => {
    const bodyImprimir = muestras.map((muestra) => muestra.id);
    imprimirMuestras(bodyImprimir)
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "muestras.pdf"); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error al descargar el PDF:", error);
      });
  };
  const handleImprimirMuestraEspecifica = (id, codigo) => {
    const bodyImprimir = id;
    imprimirMuestras(bodyImprimir)
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "muestra-" + codigo + ".pdf"); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error al descargar el PDF:", error);
      });
  };
  const handleClickButtonTable = (value, valueRow) => {
    const val = value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

    if (value === "Ver") {
      setModalStatus(true);
      setTypeModal("verMuestrasClientesExternos");
      setDatosModal(valueRow);
    }
  };
  const handleOrderClick = (value) => {
    const type = "infoMuestras";
    const newOrder = handleOrder(value, orderBy, type);
    setOrderBy(newOrder);
  };
  const handleChangePlanta = (value) => {
    setSelectedOptionPla(!value ? null : value);
  };
  const handleChangeEquipo = (value) => {
    setSelectedOptionEquipo(!value ? null : value);
  };
  const handleChangePuntoDeToma = (value) => {
    setSelectedOptionPuntoDeToma(!value ? null : value);
  };
  const handleChangeComponente = (value) => {
    setSelectedOptionComponente(!value ? null : value);
  };
  const handleChangeLubricante = (value) => {
    setSelectedOptionLubricante(!value ? null : value);
  };
  const handleBuscador = (value, type) => {
    if (type === "nroMuestra") {
      setSearchNroMuestra(value);
    }
    if (type === "nroOt") {
      setSearchNroOt(value);
    }
  };
  const handleChangeCheckBox = (nombre, value) => {
    setCheckboxState((prev) => {
      const nuevoEstado = { ...prev, [nombre]: value };

      const seleccionados = estadosFinales
        .filter((item) => nuevoEstado[item.id])
        .map((item) => item.id);


      if (seleccionados.length > 0) {
        setCheckBoxBack(seleccionados.join(','));
      } else {
        setCheckBoxBack("");
      }

      return nuevoEstado;
    });
  };
  const handleClickClear = () => {
    setSelectedOptionPla(null);
    setSelectedOptionEquipo(null);
    setSelectedOptionPuntoDeToma(null);
    setSelectedOptionComponente(null);
    setSelectedOptionLubricante(null);
    setSearchNroMuestra("");
    setSearchNroOt("");
    setCheckboxState({});
    setCheckBoxBack("");
    setSearchDesde(null);
    setSearchHasta(null);
    setFechaErrorCalendar("");
    setContinuarCalendar(true);
    setMostrarChip(false);
  };

  //calendarios
  const handleClickCalendarOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseCalendar = () => {
    setAnchorEl(null);
  };
  const handleDeleteChip = () => {
    setAnchorEl(null);
    setSearchDesde(null);
    setSearchHasta(null);
    setMostrarChip(false);
    setContinuarCalendar(false);
  }
  const open = Boolean(anchorEl);
  const id = open ? "periodo-popover" : undefined;
  return (
    <Styled>
      <Preloader
        title="Cargando..."
        subtitle={"Espere unos Segundos por favor..."}
        loading={isLoading}
      />

      <div classname="toast">
        {success ? (
          <Toast key={key} title={msjToast} close={() => setSuccess(false)} />
        ) : null}
        {error ? (
          <Toast
            key={key}
            type={"error"}
            title={msjToast}
            close={() => setError(false)}
          />
        ) : null}
      </div>

      <Modal
        datos={datosModal}
        isOpen={statusModal}
        type={typeModal}
        onClose={({ msj, status }) => {
          setSuccess(false);
          setError(false);
          if (status === "success") {
            setKey(key + 1);
            if (msj !== "Diagnostico") setSuccess(true);
            if (msj !== "Diagnostico") setMsjToast(msj);
          } else if (status === "error") {
            setError(true);
            setMsjToast(msj);
          } else if (status === "cancel") {
          }
          setModalStatus(false);
        }}
      />
      <StyledTypography>Informes de Muestras</StyledTypography>

      <BoxHeader>
        <BoxInputs>
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Input
              isClearable
              reactSelect
              options={plantas}
              stylesHeader
              onChange={(e) => {
                handleChangePlanta(e);
              }}
              value={selectedOptionPla}
              placeholder={"Seleccione la Planta"}
              showSubLabel
            />
            <Input
              isClearable
              reactSelect
              options={equipo}
              stylesHeader
              onChange={(e) => {
                handleChangeEquipo(e);
              }}
              value={selectedOptionEquipo}
              placeholder={"Seleccione el Equipo"}
              showSubLabel
            />
            <Input
              isClearable
              reactSelect
              options={puntoDeToma}
              stylesHeader
              onChange={(e) => {
                handleChangePuntoDeToma(e);
              }}
              value={selectedOptionPuntoDeToma}
              placeholder={"Seleccione el Punto de Toma"}
              showSubLabel
            />
            <Input
              inputProp={true}
              positionIcon={"start"}
              placeholder={"Buscar por nro. muestra"}
              icon={<Search />}
              size={"small"}
              search={"true"}
              value={searchNroMuestra}
              isClearable={() => setSearchNroMuestra("")}
              onChange={(e) => handleBuscador(e.target.value, "nroMuestra")}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              width: "100%",
              divInput: {
                width: "100%",
              },
            }}
          >
            <Input
              isClearable
              reactSelect
              options={componente}
              stylesHeader
              onChange={(e) => {
                handleChangeComponente(e);
              }}
              value={selectedOptionComponente}
              placeholder={"Seleccione  el componente"}
            />
            <Input
              isClearable
              reactSelect
              options={lubricante}
              stylesHeader
              onChange={(e) => {
                handleChangeLubricante(e);
              }}
              value={selectedOptionLubricante}
              placeholder={"Seleccione  el Lubricante"}
              showSubLabel
            />
            <Input
              inputProp={true}
              positionIcon={"start"}
              placeholder={"Buscar por nro. de OT"}
              icon={<Search />}
              size={"small"}
              search={"true"}
              value={searchNroOt}
              isClearable={() => setSearchNroOt("")}
              onChange={(e) => handleBuscador(e.target.value, "nroOt")}
            />
          </Box>
          <Box sx={{
            display: "flex", gap: "10px", alignItems: {
              xs: "center",
              sm: "flex-end",
            },
          }}>
            <CustomButton
              label={"Período"}
              startIcon={<CalendarMonth />}
              variant={"contained"}
              className="buttonColorTable"
              onClick={
                handleClickCalendarOpen
              }
            />
            {mostrarChip &&
              <Chip
                label={`Periodo ${formatearFecha(searchDesde)} - ${formatearFecha(searchHasta)}`}

                sx={{
                  minWidth: "200px",
                  fontSize: "15px",
                  fontWeight: 500,
                  color: colors.blueDark,
                  backgroundColor: colors.lightTurquoise,
                  fontFamily: fonts.primary,
                  '& .MuiChip-deleteIcon': {
                    color: colors.darkGrayDos,
                    '&:hover': {
                      color: "black",
                      cursor: "pointer"
                    }
                  }

                }}
                onDelete={handleDeleteChip}
              />
            }
          </Box>


          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleCloseCalendar}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            slotProps={{
              paper: {
                sx: {
                  p: 2,

                },
              },
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: "5px", p: "2", height: "auto" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                <Box sx={{ display: "flex", gap: 2 }}>
                  <DatePicker
                    clearable
                    label="Desde"
                    placeholder="Desde"
                    format="DD/MM/YYYY"
                    value={searchDesde}
                    onChange={(newValue) => {
                      if (newValue === null) {
                        setSearchDesde(null);
                        setSearchHasta(null);
                        setFechaErrorCalendar("");
                        setContinuarCalendar(true);
                        return;
                      }
                      if (searchHasta && newValue && searchHasta.isBefore(newValue, "day")) {
                        setFechaErrorCalendar("La fecha hasta no puede ser menor a la fecha desde");
                      } else {
                        setFechaErrorCalendar("");
                        setSearchDesde(newValue);
                      }
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        sx: {
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            borderColor: "transparent",
                            background: "#f8f7f7",
                            "& fieldset": {
                              borderColor: "transparent",
                            },
                            "&:hover fieldset": {
                              borderColor: "transparent",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "transparent",
                            },
                          },
                        },
                      },
                      actionBar: {
                        actions: searchDesde ? ['clear'] : [],
                      },
                    }}
                  />
                  <DatePicker
                    clearable
                    format="DD/MM/YYYY"
                    label="Hasta"
                    placeholder="Hasta"
                    disabled={!searchDesde}
                    value={searchHasta}
                    onChange={(newValue) => {
                      if (newValue === null) {
                        setSearchHasta(null);
                        setFechaErrorCalendar("");
                        setContinuarCalendar(true);
                        return;
                      }
                      if (searchDesde && newValue && newValue.isBefore(searchDesde, "day")) {
                        setFechaErrorCalendar("La fecha hasta no puede ser menor a la fecha desde");
                      } else {
                        setFechaErrorCalendar("");
                        setSearchHasta(newValue);
                      }
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        sx: {
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            borderColor: "transparent",
                            background: "#f8f7f7",
                            "& fieldset": {
                              borderColor: "transparent",
                            },
                            "&:hover fieldset": {
                              borderColor: "transparent",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "transparent",
                            },
                          },
                        },
                      },
                      actionBar: {
                        actions: searchHasta ? ['clear'] : [],
                      },
                    }}
                    minDate={searchDesde}
                  />

                </Box>
              </LocalizationProvider>
              {fechaErrorCalendar && (
                <Typography sx={{
                  color: colors.error,
                  fontSize: "15px",
                  fontFamily: fonts.primary,
                  fontWeight: "500",
                }}>
                  {fechaErrorCalendar}
                </Typography>
              )}
              <Box sx={{ margin: "auto", p: 2 }}>
                <CustomButton
                  label={"Continuar"}
                  variant={"contained"}
                  // className="buttonColorTable"
                  disabled={
                    !searchDesde ||
                    !searchHasta ||
                    (searchHasta && searchDesde && searchHasta.isBefore(searchDesde, 'day'))
                  }
                  onClick={() => {
                    setContinuarCalendar(true);
                    setAnchorEl(null);
                    setMostrarChip(true);
                  }}
                />
              </Box>
            </Box>
          </Popover>


        </BoxInputs>
      </BoxHeader>

      <BoxSubHeader>
        <Box>
          <FormGroup sx={{ flexDirection: 'row', gap: 1 }}>
            {estadosFinales?.map((res, index) => (
              <FormControlLabel
                key={index}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <RenderImgStyled img={`data:image/png;base64,${res.icon}`} sx={{ width: 25, height: 25 }} />
                    <span>{res.label}</span>
                  </Box>
                }
                control={
                  <Checkbox
                    checked={cargarCheckbox(res.id)}
                    onChange={(e) => handleChangeCheckBox(res.id, e.target.checked)}
                    sx={{
                      color: getColorTraductor(res.color),
                      '&.Mui-checked': {
                        color: getColorTraductor(res.color),
                      },
                      '&:hover': {
                        backgroundColor: `${getColorTraductor(res.color)}22`,
                      },
                    }}
                  />
                }
              />
            ))}
          </FormGroup>
        </Box>
        <Box>
          <CustomButton
            label={"Resumen de Informes"}
            startIcon={<RenderImgStyled img={Print} />}
            variant={"contained"}
            className="buttonColorTable"
            onClick={() => {
              handleImprimirResumen();
            }}
          />
        </Box>
      </BoxSubHeader>
      <Box sx={{ display: "flex", gap: "10px", alignItems: "center", width: "98%" }}>
        <RenderImg img={SetIcon} alt="skf" className="img" />
        <Typography
          sx={{
            fontFamily: fonts.primary,
            "&:hover": { textDecoration: "underline" },
            cursor: "pointer",
            color: colors.steelBlue,
            fontWeight: "400",
          }}
          onClick={() => {
            handleClickClear();

          }}
        >
          Limpiar filtros
        </Typography>
        <Box sx={{
          width: 40,
          height: 40,
          ml: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          visibility: loader ? 'visible' : 'hidden',

        }}>
          {loader && <CircularProgress size={35} />}
        </Box>
      </Box>
      <Tables
        typeTable={"prop"}
        columns={columns}
        rows={muestras}
        cRows={20}
        totalRows={itemsCount}
        actualpage={paginaActual}
        pagination={true}
        onClickSwitch={(value) => {
          handleOrderClick(value);
        }}
        page={(e) => {
          setDesdePaginador(true);
          setPaginaActual(e + 1);
        }}
        pages={pageCount}
        buttons={buttonsMuestrasForClient}
        onClickButtonTable={(value, valuesRow) => {
          if (value === "Imprimir") {
            handleImprimirMuestraEspecifica([valuesRow.id], valuesRow.codigo);
          } else {
            handleClickButtonTable(value, valuesRow);
          }
        }}
      />

      <Modal
        datos={datosModal}
        isOpen={statusModal}
        onClose={() => {
          setModalStatus(false);
        }}
        type={typeModal}
      />
      {muestras?.length > 16 &&
        <Box sx={{
          width: 40,
          height: 40,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          visibility: loader ? 'visible' : 'hidden',

        }}>
          {loader && <CircularProgress size={35} />}
        </Box>
      }
    </Styled>
  );
};

export default InfoMuestras;
// {datosCheckBox?.map((res, index) => {
//         return (

//           <Checkboxx
//             key={index}
//             label={res.label}
//             checked={cargarCheckbox(res.name)}
//             onChange={(e) => {
//               handleChangeCheckBox(res.name, e.checked);
//             }}
//           />
//         );
//       })}
